



















































import Vue from "vue";
import { APP_STATE } from "./state/screens";
import { TIMER_STATE } from "./state/timer";
import RbGoogCtTimeInput from "./components/RbGoogCtTimeInput.vue";
import RbGoogCtTimer from "./components/RbGoogCtTimer.vue";
import RbGoogCtButtons from "./components/RbGoogCtButtons.vue";

export default Vue.extend({
  name: "App",
  components: {
    RbGoogCtTimeInput,
    RbGoogCtTimer,
    RbGoogCtButtons,
  },
  data() {
    const appState: string = APP_STATE.Input;
    const timerState: string = TIMER_STATE.SettingUp;
    const hours: string = "";
    const minutes: string = "";
    const seconds: string = "";
    const noTimeInput = true;
    return {
      appState,
      timerState,
      hours,
      minutes,
      seconds,
      noTimeInput,
    };
  },
  methods: {
    isTimerActive() {
      return [
        "RUNNING",
        "RESUMED",
        "STARTED",
        "RESTART",
        "PAUSED",
        "ENDING",
        "RESET",
      ].includes(this.timerState) === true
        ? true
        : false;
    },
    prepareToEnd() {
      this.timerState = TIMER_STATE.AboutToEnd;
    },
    hideStartButton(ifAllZeroEntered: boolean): void {
      this.noTimeInput = ifAllZeroEntered === true ? true : false;
    },
    hideInputStartTimer(): void {
      if (navigator && typeof navigator.vibrate === "function") {
        navigator.vibrate([10]);
      }
      this.storeSetTime();
      this.timerState = TIMER_STATE.Started;
      this.appState = APP_STATE.Running;
    },
    stopTimerShowInput(): void {
      if (navigator && typeof navigator.vibrate === "function") {
        navigator.vibrate([400]);
      }
      this.timerState = TIMER_STATE.SettingUp;
      this.appState = APP_STATE.Input;
      document.title = "COUNTDOWN TIMER";
    },
    storeSetTime(): void {
      if (this.hours !== "" && this.minutes !== "" && this.seconds !== "") {
        localStorage.setItem("hours", this.hours);
        localStorage.setItem("minutes", this.minutes);
        localStorage.setItem("seconds", this.seconds);
      }
    },
    resetTimers(): void {
      this.timerState = TIMER_STATE.Reset;
      this.hours = localStorage.getItem("hours") ?? "";
      this.minutes = localStorage.getItem("minutes") ?? "";
      this.seconds = localStorage.getItem("seconds") ?? "";
    },
    pauseTimers(): void {
      this.timerState = TIMER_STATE.Paused;
    },
    resumeTimers(): void {
      this.timerState = TIMER_STATE.Resumed;
    },
    restartTimers(): void {
      this.timerState = TIMER_STATE.Restart;
    },
    onTimerUp(): void {
      this.timerState = TIMER_STATE.Stopped;
    },
    setTimeForCountDown(
      inHours: string,
      inMinutes: string,
      inSeconds: string
    ): void {
      this.hours = inHours.replaceAll("-", "0");
      this.minutes = inMinutes.replaceAll("-", "0");
      this.seconds = inSeconds.replaceAll("-", "0");
    },
  },
});
